<template>
  <v-row justify="center">
    <v-dialog v-model="internalDialogActive" persistent max-width="290">
      <v-card class="text-center pa-10 justify-center">
        <v-progress-circular
          class="mt-3"
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
        <v-card-title class="text-title justify-center mt-2">
          {{ message }}
        </v-card-title>
        <v-card-text>Aguarde..</v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "LoaderDialogView",
  props: {
    activeDialog: { type: Boolean, default: false },
    message: { type: String, default: "Carregando" },
  },
  data() {
    return {
      internalDialogActive: false,
    };
  },
  watch: {
    activeDialog(newValue) {
      this.internalDialogActive = newValue;
    },
  },
  mounted() {
    this.internalDialogActive = this.activeDialog;
  },
};
</script>
